import './toggleButton.css';

/**
 * Toggle button Component
 * @usage
 *   const toggleButton = new ToggleButton({
 *     name: `sg-toggle-button-1`,
 *     label: 1,
 *     classNames: ['lorem','ipsum'],
 *     disabled: false,
 *   });
 *   toggleButton.render();
 */
export class ToggleButton {
  /**
   * Constructor
   * @param {object} params
   * @param {boolean} params.checked
   * @param {boolean} params.disabled
   * @param {string} params.id
   * @param {string} params.name
   * @param {string} params.label
   * @param {object} params.value
   * @param {string[]} params.classNames
   * @param {object} params.attributes
   * @param {object} params.inputClassNames
   */
  constructor(params) {
    this.checked = params.checked || false;
    this.disabled = params.disabled || false;
    this.id = params.id;
    this.name = params.name || params.id;
    this.label = params.label;
    this.value = params.value;
    this.baseClass = 'toggleButton';
    this.classNames = params.classNames ? [this.baseClass, ...params.classNames] : [this.baseClass];
    this.inputClassNames = params.inputClassNames || [];
    this.attributes = params.attributes || {};
  }

  /**
   * Render component template
   * @return {string}
   */
  render(isHtml = true) {
    const container = $('<div />').addClass(this.classNames.join(' '));
    const inputAttr = $.extend({}, {
      id: this.id,
      name: this.name,
      disabled: this.disabled,
      checked: this.checked
    }, this.attributes);

    const input = $('<input type="checkbox" />')
      .addClass([
        `${this.baseClass}-input`,
        this.checked ? 'is-checked' : '',
        this.disabled ? 'is-disabled' : '',
        this.inputClassNames.join(' ')
      ])
      .attr(inputAttr)
      .val(this.value);

    const label = $('<label />')
      .addClass(`${this.baseClass}-label`)
      .attr({for: this.id})
      .html(this.label);

    container.append([input, label]);

    return isHtml ? container.prop('outerHTML') : container;
  }
}